import { BOX_RECOMMENDER_PATHS } from 'lib/constants';

import BoxQuestions from './BoxQuestions';
import DietaryPreferencesContainer from './DietaryPreferencesContainer';
import IntroContainer from './IntroContainer';
import RecommendationsContainer from './RecommendationsContainer';

export const Steps = [
  {
    id: 'intro',
    title: "Dinner's just 2 minutes away!",
    subtitle: "Let's get you set up to pick your meals.",
    content: IntroContainer,
    pathname: '',
  },
  {
    id: 'dietaryPreferences',
    title: 'What meals are you interested in?',
    subtitle: "You'll still have access to the full menu.",
    content: DietaryPreferencesContainer,
    pathname: '',
  },
  {
    id: 'servingPreferences',
    title: 'How many people are eating?',
    subtitle: 'This helps us recommend a plan. Adjust any time.',
    content: BoxQuestions,
    pathname: BOX_RECOMMENDER_PATHS.BOX_PEOPLE,
  },
  {
    id: 'mealPreferences',
    title: 'How many meals will Tempo cover?',
    subtitle: 'This helps us recommend a plan. Adjust any time.',
    content: BoxQuestions,
    pathname: BOX_RECOMMENDER_PATHS.BOX_MEALS,
  },
  {
    id: 'dayPreferences',
    title: 'How many days a week do you want Tempo meals?',
    subtitle: 'This helps us recommend a plan. Adjust any time.',
    content: BoxQuestions,
    pathname: BOX_RECOMMENDER_PATHS.BOX_DAYS,
  },
  {
    id: 'recommendations',
    title: 'Your single-serving weekly meal plan',
    subtitle: 'Recommended based on your answers. You can adjust your order size at any time.',
    content: RecommendationsContainer,
    pathname: '',
  },
];
